import { Injectable } from '@angular/core';
import { GlobalsService } from '@services/global.service';
import AppConfiguration from '@hal.common.ui/utilities/AppConfig';
import { HttpResponse } from '@angular/common/http';
import { StocktakeItemsService as SDKStocktakeItemsService } from '@modules/SDKs/sysnetApi/api/stocktakeItems.service';
import { GroupQuery, GroupSummaryQuery, StocktakeItemView } from '@modules/SDKs/sysnetApi';
import { ServicesWrappingSysnetSDK } from './ServicesWrappingSysnetSDK';

@Injectable({
    providedIn: 'root'
})
export class StocktakeItemsService extends ServicesWrappingSysnetSDK {
    private orgId: string;

    constructor(private sdkStocktakeItemsService: SDKStocktakeItemsService, private globals: GlobalsService) {
        super([sdkStocktakeItemsService], globals);
        this.globals.$state.subscribe((newState) => {
            if (newState) { this.orgId = newState.selectedOrganisation?._id; }
        });
    }

    // Get StocktakeItem
    public getStocktakeItem(stocktakeItemId: number): Promise<HttpResponse<StocktakeItemView>> {
        return this.sdkStocktakeItemsService.stocktakeItemsIdGet(stocktakeItemId, AppConfiguration.rsh.getStrVal('rid'), null, 'response').toPromise();
    }

    // Search StocktakeItems
    public searchStocktakeItems(
        group?: GroupQuery,
        groupSummary?: GroupSummaryQuery,
        totalSummary?: GroupSummaryQuery,
        sort?: string,
        limit?: number,
        offset?: number,
        view?: string,
        search?: object,
        searchDistinct?: string): Promise<HttpResponse<StocktakeItemView[]>> {
        return this.sdkStocktakeItemsService.stocktakeItemsGet(AppConfiguration.rsh.getStrVal('rid'), view,
            this.stringify(group), this.stringify(groupSummary), this.stringify(totalSummary), searchDistinct, sort, limit, offset, this.stringify(search),
            null, null, null, null, null, null, null, null, null, null, null, null, this.orgId, null, 'response').toPromise();
    }

    // Delete StocktakeItem
    public deleteStocktakeItem(stocktakeItemId: number): Promise<HttpResponse<StocktakeItemView>> {
        return this.sdkStocktakeItemsService.stocktakeItemsIdDelete(stocktakeItemId, AppConfiguration.rsh.getStrVal('rid'), 'response').toPromise();
    }

    public async countUncountedItems(
        stocktakeId: number
    ): Promise<number> {
        const limit = 1;
        const offset = 0;
        const stocktakeItemsRes = await this.searchStocktakeItems(null, null, null, null, limit, offset, null, { $and: [{ stocktakeId: { $eq: stocktakeId } }, { counted: { $eq: false } }] }, null);
        const count = +stocktakeItemsRes.headers.get('total_available_results_count');
        return count;
    }

}
